import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { SERVER_AVAILABLE } from 'src/app/services/synchronization-constants';
import { HttpErrorService } from './http-error.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private readonly httpErrorService: HttpErrorService,
        @Inject(SERVER_AVAILABLE) private readonly serverAvailable$: BehaviorSubject<boolean>,
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap((event) => {
                if (event.type === HttpEventType.Response) this.updateAvailability(request.url);
            }),
            catchError((errorResponse: HttpErrorResponse) => {
                // If the request explicitly asked to skip global error handling,
                // rethrow the original error so caller-level catchError can handle it.
                if (request.headers && request.headers.has('X-Skip-Global-Error')) {
                    return throwError(() => errorResponse);
                }
                return this.httpErrorService.handleError(errorResponse);
            }),
        );
    }

    updateAvailability(url: string): void {
        const workerCachedUrls = ['/api/account', '/api/reference'];
        if (workerCachedUrls.every((cachedUrl) => !url.startsWith(cachedUrl))) this.serverAvailable$.next(true);
    }
}
